import { graphClient } from '../../graph-client'
import {
  CREATE_USER_HOST_TASK_SPECIAL,
  GET_USER_HOST_TASK_SPECIAL,
  GET_USER_HOST_TASK_SPECIAL_FIRST,
  GET_USERS_HOSTS_TASKS_SPECIALS,
  UPDATE_USER_HOST_TASK_SPECIAL,
} from './gql'

import type {
  Create,
  Get,
  GetFirst,
  GetList,
  Update,
} from './types'

class UserHostTaskSpecialService {
  async create(params: Create.Input) {
    const request = await graphClient.request<Create.Output>(
      CREATE_USER_HOST_TASK_SPECIAL,
      params,
    )
    return request?.createUserHostTaskSpecial
  }

  async update(params: Update.Input) {
    const request = await graphClient.request<Update.Output>(
      UPDATE_USER_HOST_TASK_SPECIAL,
      params,
    )
    return request?.updateUserHostTaskSpecial
  }

  async get(params: Get.Input) {
    const request = await graphClient.request<Get.Output>(
      GET_USER_HOST_TASK_SPECIAL,
      params,
    )
    return request?.getUserHostTaskSpecial
  }

  async getFirst(params: GetFirst.Input) {
    const request = await graphClient.request<GetFirst.Output>(
      GET_USER_HOST_TASK_SPECIAL_FIRST,
      params,
    )
    return request?.getUserHostTaskSpecialFirst
  }

  async getList({ take = 20, skip = 0, ...params }: GetList.Input) {
    const request = await graphClient.request<GetList.Output>(
      GET_USERS_HOSTS_TASKS_SPECIALS,
      { ...params, skip: take * skip },
    )
    return request?.getUsersHostsTasksSpecials
  }
}

export const userHostTaskSpecialService = new UserHostTaskSpecialService()
